import React, { Fragment } from 'react';
import DesktopViewer from './desktop/Viewer';
import {
  DOCUMENT_DISPLAY_MODE_DESKTOP_WINDOW,
  DOCUMENT_DISPLAY_MODE_INPAGE
} from '../helpers/utils';
import MobileViewer from './mobile/Viewer';
import PropTypes from 'prop-types';
import DesktopInPageViewer from './desktop/InPageViewer';

const Viewer = props => {
  return props.displayMode === DOCUMENT_DISPLAY_MODE_INPAGE ? (
    <DesktopInPageViewer {...props} />
  ) : (
    <Fragment>
      {props.displayMode === DOCUMENT_DISPLAY_MODE_DESKTOP_WINDOW ? (
        <DesktopViewer {...props} />
      ) : (
        <MobileViewer {...props} />
      )}
    </Fragment>
  );
};

Viewer.propTypes = {
  displayMode: PropTypes.string
};

export default Viewer;
